import BootstrapModal from "bootstrap/js/dist/modal";

import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { UserAvatar } from "./user-avatar.js";

UserAvatar.Register();

/**
 * Display totals of all types of likes on an entity, clickable to see individual like details
 * Expects the entity property to be a vwPost
 */
export class PostLikesDisplay extends UnshadowedElement {
    static elementName() { return "post-likes-display" }

    static properties = {
        entity: { type: Array },
        isInModal: { type: Boolean },

        showingModal: { state: true, type: Boolean },
    };

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("postLikeChange", e => this.ExternalLikeChange(e));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("postLikeChange", e => this.ExternalLikeChange(e));
    }

    /** When likes are modified externally, update the array */
    ExternalLikeChange(e) {
        if (!this.entity) return;
        if (e && this.entity && this.entity.Post && e.detail.postId === this.entity.Post.Id) {
            this.entity.PostLikes = e.detail.likes;
            this.requestUpdate();
        }
    }

    render() {
        if (!this.entity || !this.entity.PostLikes || !this.entity.PostLikes.length) return null
        const bins = new Map();
        // Sort the array of likes into a map of arrays by TypeId
        for (const like of this.entity.PostLikes) {
            const bin = bins.get(like.TypeId);
            if (bin) {
                bin.push(like);
            } else {
                bins.set(like.TypeId, [like]);
            }
        }
        const icons = [];
        bins.forEach((value, key) => {
            // Note: Could do title with value.length if we want hover counts
            icons.push(html`<svg role="img" width="32" height="32"><use href="#${LikeSvgSmall[key]}" /></svg>`);
        });

        return html`
            ${this.isInModal ? html`
                <div>
                    <div class="current-reactions">${icons}</div>
                    <div>${this.entity.PostLikes.length}</div>
                </div>
            ` : html`
                <button @click=${() => this.showingModal = true} class="view-reactions-button">
                    <div class="current-reactions">${icons}</div>
                    <div>${this.entity.PostLikes.length}</div>
                </button>
            `}
            ${this.showingModal ? html`
                <div class="modal fade reactions-modal" id="modalShowLikes" tabindex="-1" aria-labelledby="modalShowLikesTitle" aria-hidden="true">
                    <div class="modal-dialog modal-fullscreen-sm-down">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="modalShowLikesTitle">
                                    Reactions
                                </h3>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                ${this.entity.PostLikes.map(like => html`
                                    <div class="participant-row">
                                        <div class="participant-row__content">
                                            <user-avatar avatar=${like.Author.Avatar} initials=${like.Author.Initials}></user-avatar>
                                            <div class="participant-row__body">
                                            <h4 class="participant-row__title">
                                                ${like.Author.FullName}
                                            </h4>
                                        </div>
                                        <div class="participant-row__actions">
                                            <svg role="img" width="50" height="50"><use href="#${LikeSvgSmall[like.TypeId]}" /></svg>
                                        </div>
                                    </div>
                                `)}
                            </div>
                        </div>
                    </div>
                </div>
            ` : null}
        `;
    }

    // We have to show the bootstrap modal if we made one in render()
    updated() {
        const modalDiv = document.getElementById("modalShowLikes");
        if (modalDiv) {
            const modal = BootstrapModal.getOrCreateInstance(modalDiv);
            modal.show();
            // When the modal is hidden, turn off showingModalDay so we don't reshow the modal
            modalDiv.addEventListener("hidden.bs.modal", () => { this.showingModal = undefined; });
        }
    }
}

export const LikeSvgSmall = {
    0: "reaction-hug-sm",
    1: "reaction-heart-sm",
    2: "reaction-like-sm",
    3: "reaction-smile-sm",
}
export const LikeSvgLarge = {
    0: "reaction-hug-lg",
    1: "reaction-heart-lg",
    2: "reaction-like-lg",
    3: "reaction-smile-lg",
}